/**
 * FlahaSOIL v2 — PrintStyles (Phase 10D.1).
 *
 * Global CSS injection for high-fidelity browser printing.
 * Implements A4 sizing, cover-page page-break, hiding app chrome,
 * and print-safe chart containers.
 *
 * Known limitation: browser-injected URL/date/page-number headers and
 * footers cannot be suppressed via CSS alone. Users must disable them
 * manually in the browser print dialog ("Headers and footers" option).
 */
import { GlobalStyles } from "@mui/material";

export function PrintStyles() {
  return (
    <GlobalStyles
      styles={{
        "@page": {
          size: "A4",
          margin: 0,
        },
        "@media print": {
          /* ── App chrome: hide everything that is not the report ── */
          ".no-print, nav, header, aside, .MuiDrawer-root, .MuiAppBar-root, .report-actions": {
            display: "none !important",
          },
          /* ── Body reset ─────────────────────────────────────────── */
          "body, html": {
            margin: "0 !important",
            padding: "0 !important",
            backgroundColor: "#FFFFFF !important",
            WebkitPrintColorAdjust: "exact",
            printColorAdjust: "exact",
          },
          /* ── Cover page: fills first page, forces break after ───── */
          ".report-cover-page": {
            width: "210mm",
            minHeight: "297mm",
            breakAfter: "page",
            pageBreakAfter: "always",
            margin: "0 !important",
            padding: "0 !important",
            overflow: "hidden",
          },
          /* ── Report sections: avoid awkward mid-section splits ──── */
          ".report-section": {
            breakInside: "avoid",
            pageBreakInside: "avoid",
          },
          /* ── Legacy helpers ─────────────────────────────────────── */
          ".page-break": {
            pageBreakBefore: "always",
            breakBefore: "page",
          },
          ".no-break": {
            pageBreakInside: "avoid",
            breakInside: "avoid",
          },
          /* ── Typography: prevent orphaned headings ──────────────── */
          "h1, h2, h3, h4": {
            pageBreakAfter: "avoid",
            breakAfter: "avoid",
          },
          /* ── Tables / images / cards: no splits ─────────────────── */
          "table, .MuiCard-root": {
            pageBreakInside: "avoid",
            breakInside: "avoid",
          },
          "img": {
            maxWidth: "100% !important",
            pageBreakInside: "avoid",
            breakInside: "avoid",
          },
          /* ── Charts: full-width, height constrained ─────────────── */
          ".chart-container": {
            width: "100% !important",
            maxHeight: "220px !important",
            overflow: "hidden !important",
          },
        },
      }}
    />
  );
}
